const sessionKey = "sibilus_whoami_session_id";
const usernameKey = "sibilus_whoami_username"
const companyKey = "sibilus_whoami_company_id"

export const RefreshSession = (session_id) => {
	if (session_id) {
		sessionStorage.setItem(sessionKey, session_id);
	} 
};

export const saveLocalStorage = (value, username=false) => {
	const key = username ? usernameKey : sessionKey 
	localStorage.setItem(key, value)
}

export const logout = () => {
	localStorage.removeItem(sessionKey)
	localStorage.removeItem(usernameKey)
}

export const saveCompanyChoice = (companyId) => {
	localStorage.setItem(companyKey, companyId)
}

export const getCompanyChoice = () => {
	return localStorage.getItem(companyKey) || undefined
}

export const getSession = () => {
	return localStorage.getItem(sessionKey) || undefined
}

export const getSavedUserName = () => {
	const presetUsername = localStorage.getItem(usernameKey) || ""
	return presetUsername
}

